import { ChangeEvent, ReactNode } from 'react';
import { useField } from 'formik';
import { RadioGroup, RadioOptionType } from '../RadioGroup/RadioGroup';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { ResponseErrorType } from '@/types/sharedTypes';

interface FormikRadioGroupType {
  label: ReactNode;
  name: string;
  options: ReadonlyArray<RadioOptionType>;
  disabled?: boolean;
  apiError?: ResponseErrorType;
  hasErrorComponent?: boolean;
  gridMode?: boolean;
}

export const FormikRadioGroup = ({
  label,
  name,
  options,
  disabled,
  apiError,
  hasErrorComponent,
  gridMode,
}: FormikRadioGroupType) => {
  const [field, meta, { setValue }] = useField(name);

  const { apiError: apiErrorMessage, error } = getFieldError(name, meta, apiError);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <RadioGroup
      {...field}
      label={label}
      value={field.value}
      onChange={handleChange}
      options={options}
      disabled={disabled}
      error={error}
      apiError={apiErrorMessage}
      hasErrorComponent={hasErrorComponent}
      gridMode={gridMode}
    />
  );
};
